import React from "react";
import fetchData from "../api/Apicall";
import PaginatedMovieGrid from "./PaginatedMovieGrid";

const NowPlayA = () => (
  <PaginatedMovieGrid title="Now Playing Movies" fetcher={fetchData} />
);

export default NowPlayA;
